<template>
    <div class="home-region disease"> 
        <div class="region-cont disease-cont">
            <!-- <div class="tit tit-blue">中医药知识图谱 · 疾病画像 
                <div class="tit-bottom"></div>
            </div> --> 
            <div class="disease-left">
                <h2 class="disease-title">中医药知识图谱 · 疾病画像</h2>
                <p class="disease-sub">医疗、科研、科普三驱一体</p>
                <p class="disease-desc">整合中医药数据，可视化呈现疾病知识体系</p>
                <div class="disease-btn" @click="toSystem">立即访问系统</div>
                <div class="example-word">
                    <p class="example-label">一键直达</p>
                    <ul class="example-list">
                        <li
                            class="example-item"
                            v-for="(item, index) in exampleWords"
                            :key="index"
                            @click="toDiseasePage(item)"
                        >{{ item }}</li>
                    </ul>
                </div>
            </div>
            <div class="disease-right">
                <div class="chart-card">
                    <p class="chart-tit">用药分布关联</p>
                    <div class="chart-img">
                        <img src="@/assets/images/home/disease-pic1.png" alt="用药分布关联">
                    </div>
                </div>
                <div class="chart-card">
                    <p class="chart-tit">治疗方案分布</p>
                    <div class="chart-img">
                        <img src="@/assets/images/home/disease-pic2.png" alt="治疗方案分布">
                    </div>
                </div>
                <div class="chart-card">
                    <p class="chart-tit">疾病年龄分布</p>
                    <div class="chart-img">
                        <img src="@/assets/images/home/disease-pic3.png" alt="疾病年龄分布">
                    </div>
                </div>
                <div class="chart-card">
                    <p class="chart-tit">科普类别分布</p>
                    <div class="chart-img">
                        <img src="@/assets/images/home/disease-pic4.png" alt="科普类别分布">
                    </div>
                </div>
            </div> 
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            exampleWords: [
                '糖尿病',
                '高血压',
                '冠心病',
                '中风',
                '哮喘',
                '胃脘痛',
                '痛经',
                '颈椎病',
                '失眠',
                '湿疹',
            ],
        };
    },
    methods: {
        toSystem() {
            const url = this.$router.resolve({
                path: '/diseasePage', 
            });
            this.$windowOpen({ url: url.href, isLogin: true });
        },
        toDiseasePage(word) {
            const url = this.$router.resolve({
                path: '/diseaseGraph',
                query: {
                    word,
                    tab: 'doctor',
                },
            });
            this.$windowOpen({ url: url.href, isLogin: true });
        },
    },
};
</script>

<style lang="less" scoped>
.disease {
    padding: 60px 0;
    background:
        linear-gradient(135deg, rgba(234, 241, 255, 0.95) 0%, rgba(229, 243, 255, 0.9) 45%, rgba(255, 255, 255, 0.98) 100%),
        radial-gradient(circle at 18% 22%, rgba(56, 109, 232, 0.08) 0%, transparent 42%),
        radial-gradient(circle at 82% 78%, rgba(22, 93, 255, 0.06) 0%, transparent 40%),
        #F5F9FF;
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background-image:
            linear-gradient(30deg, rgba(160, 207, 255, 0.22) 1px, transparent 1px),
            linear-gradient(150deg, rgba(160, 207, 255, 0.18) 1px, transparent 1px),
            linear-gradient(90deg, rgba(198, 222, 255, 0.2) 1px, transparent 1px);
        background-size: 120px 120px, 160px 160px, 80px 80px;
        background-position: 0 0, 40px 20px, 0 0;
        pointer-events: none;
        opacity: 0.55;
    } 
    .tit {
        width: 440px;
        text-align: center;
    } 
    .disease-cont {
        position: relative;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 460px;
    }

    .disease-left {
        width: 360px;
        flex-shrink: 0;
        padding-right: 20px;
        // padding-bottom: 40px;
        .disease-title {
            margin: 0;
            text-align: left;
            font-size: 40px;
            line-height: 52px;
            font-weight: bold;
            color: #0C55AA;
        }

        .disease-sub {
            margin: 40px 0 12px;
            font-size: 22px;
            line-height: 30px;
            font-weight: bold;
            color: #386DE8;
        }

        .disease-desc {
            margin: 0 0 40px;
            font-size: 14px;
            line-height: 22px;
            color: #5A6779;
        }

        .disease-btn {
            width: 160px;
            height: 44px;
            line-height: 44px; 
            text-align: center;
            background: #165DFF;
            color: #fff;
            font-size: 16px;
            font-weight: 500;
            border-radius: 8px;
            cursor: pointer;
            box-shadow: 0 8px 20px rgba(12, 85, 170, 0.28);
            transition: all 0.2s ease;

            &:hover { 
                box-shadow: 0 10px 24px rgba(22, 93, 255, 0.32);
            }
        }

        .example-word {
            margin-top: 28px;

            .example-label {
                margin: 0 0 12px;
                font-size: 13px;
                color: #5A6779;
                line-height: 18px;
            }

            .example-list {
                display: flex;
                flex-wrap: wrap;
                margin: 0 -6px -8px 0;
                padding: 0;
                list-style: none;
            }

            .example-item {
                margin: 0 6px 8px 0;
                padding: 4px 12px;
                font-size: 13px;
                line-height: 20px;
                color: #386DE8;
                background: #EAF1FF;
                border: 1px solid #C6DEFF;
                border-radius: 4px;
                cursor: pointer;
                &:hover {
                    background: #386DE8;
                    color: #fff;
                }
            }
        }
    }

    .disease-right {
        flex: 1;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
        min-width: 0;

        .chart-card {
            height: 220px;
            background: #fff;
            border-radius: 12px;
            box-shadow: 0 4px 16px rgba(56, 109, 232, 0.08);
            padding: 14px 16px 8px;
            display: flex;
            flex-direction: column;

            .chart-tit {
                margin: 0;
                font-size: 14px;
                font-weight: bold;
                color: #0C55AA;
                line-height: 20px;
            }

            .chart-img {
                width: 380px;
                height: 176px;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 100%;
                    height: auto;
                    max-height: 100%;
                    object-fit: contain;
                    display: block;
                }
            }
        }
    }
}
</style>
